/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ITeamResponse } from './ITeamResponse';
import {
    ITeamResponseFromJSON,
    ITeamResponseFromJSONTyped,
    ITeamResponseToJSON,
    ITeamResponseToJSONTyped,
} from './ITeamResponse';

/**
 * 
 * @export
 * @interface AcceptTeamInviteResponse
 */
export interface AcceptTeamInviteResponse {
    /**
     * 
     * @type {ITeamResponse}
     * @memberof AcceptTeamInviteResponse
     */
    team: ITeamResponse;
}

/**
 * Check if a given object implements the AcceptTeamInviteResponse interface.
 */
export function instanceOfAcceptTeamInviteResponse(value: object): value is AcceptTeamInviteResponse {
    if (!('team' in value) || value['team'] === undefined) return false;
    return true;
}

export function AcceptTeamInviteResponseFromJSON(json: any): AcceptTeamInviteResponse {
    return AcceptTeamInviteResponseFromJSONTyped(json, false);
}

export function AcceptTeamInviteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptTeamInviteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'team': ITeamResponseFromJSON(json['team']),
    };
}

export function AcceptTeamInviteResponseToJSON(json: any): AcceptTeamInviteResponse {
    return AcceptTeamInviteResponseToJSONTyped(json, false);
}

export function AcceptTeamInviteResponseToJSONTyped(value?: AcceptTeamInviteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': ITeamResponseToJSON(value['team']),
    };
}

